// extracted by mini-css-extract-plugin
export default {"infoPillButton":"infoPillButton_infoPillButton__xuGDV","bold":"infoPillButton_bold__0Q3+j"};